import {useEffect, useState} from 'react';

const WINDOW = '.MuiDialog-container';

/** The newest window open on the page, such as Edit contact, or null while none is open. */
export const openWindow = () => {
    const windows = Array.from(document.querySelectorAll(WINDOW)).filter(element => element.closest('[aria-hidden="true"]') === null);
    return windows.length ? windows[windows.length - 1] : null;
};

/**
 * AD-2653: while a window is open, Felicity's panel is placed inside it. The grey backdrop then
 * stays behind her, and the window lets the person type to her.
 */
const useOpenWindow = (active) => {
    const [container, setContainer] = useState(null);

    useEffect(() => {
        if (!active) {
            setContainer(null);
            return undefined;
        }

        const check = () => setContainer(current => {
            const found = openWindow();
            return found === current ? current : found;
        });
        check();
        const observer = new MutationObserver(check);
        observer.observe(document.body, {childList: true});
        return () => observer.disconnect();
    }, [active]);

    return container;
};

export default useOpenWindow;
